export default {
  it: {
    footer: {
      location: 'Dove siamo',
      hourTable: 'Orari garage'
    },
    review: {
      hero: {
        title: 'Cosa dicono <br class="hidden-sm-and-up" />i nostri clienti?',
        subtitle: 'Pareri dei nostri clienti soddisfatti.'
      }
    },
    team: {
      hero: {
        title: 'Il nostro team',
        subtitle: 'Un\'intera squadra a vostra disposizione.'
      }
    },
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
    }
  }
}
